import type { SlotGameStore } from "@gamzix/slot_core";

class Index extends SlotGame.src.component.ReelsetComponent {
    public countScatter: number = 0;
    public lastBalance: number = 0;

    onGameReady() {
        super.onGameReady();

        game.on(
            ReelsetComponent.src.BaseReel.events.REEL_SYMBOL_STOPPED,
            (data) => {
                if (data.symbolId != 0) return;
                this.countScatter++;
                this.countScatter <= 2
                    ? game.emit("ReelsetComponent.SCATTER_LAND_V2")
                    : game.emit("ReelsetComponent.SCATTER_LAND_LAST");
            }
        );
    }

    async onStartBonusGame() {
        this.playAllIdleAnimation();
    }
    async onFinishBonusGame() {}

    getFSMHandlers(): any {
        return {
            ...super.getFSMHandlers(),
            IDLE: {
                ...super.getFSMHandlers()["IDLE"],
                enter: {
                    on: () => (this.countScatter = 0),
                },
            },
            SPIN: {
                ...super.getFSMHandlers()["SPIN"],
                enter: {
                    on: () => {
                        const price: number = this.isSkipped
                            ? // @ts-ignore
                              game.component.buyFeature.realBet
                            : game.store.gameData.bet;

                        this.lastBalance = game.store.balance - price;
                    },
                },
                exit: {
                    on: () => {
                        if (game.store.gameData.bonusGame.win > 0) {
                            this.setTotalWin(0);
                        }

                        game.store.balance =
                            this.lastBalance + game.store.gameData.winAmount;
                        game.emit("UI.UPDATED");
                    },
                },
            },
        };
    }

    async startAnticipationOnReel(reel) {
        game.emit(ReelsetComponent.events.REEL_ANTICIPATION_STARTED, {
            reelId: reel.index,
        });
        reel.anticipationStart();

        await game.utils.delay(this.TIME_INTRIGUE_DELAY);
    }

    protected setTotalWin(value?: number | undefined): number {
        this.store.gameData.winAmount =
            typeof value === "number"
                ? value
                : game.store.gameData.gamble.winAmount;

        this.store.gameData.visualWinAmount = this.store.gameData.winAmount;
        game.emit("UI.UPDATED");
        return game.store.gameData.bonusGame.win;
    }
}

// @ts-ignore
Game.src.component.ReelsetComponent = Index;
